<template>
  <div>
    <TheHeader/>
    <div class="c-app flex-row align-items-center bg-overlay">    
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="5">
          <CCardGroup >
            <CCard class="pl-4 pr-4" style="background-color:rgba(0,0,0,.85); border-radius: 20px;">
              <CCardBody >
                <CForm>
                  <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:20px;">Reset Password</h1>
                  <p style="width:100%; color:#C1C1C1; text-align:center">Enter your registered email</p>
                  <div class="form-group">
                    <input
                    placeholder="Email"
                    v-model="email"
                    class="form-control material-input "
                    />
                    <small v-if="errors.email" class="form-text text-muted" style="color:red">
                      <p class="text-danger">{{errors.email}}</p>
                    </small>
                  </div>
                   
                  <CRow>
                    <CCol col="12" class="text-left">
                      <button type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="resetPassword">Send</button>
                      <!-- <CButton style="background-color:#ee8174;color:white;"  @click="onSignIn">Login
                        <b-icon v-show="loading" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
                      </CButton> -->
                    </CCol>
                    <!-- <CCol col="6" class="text-right">
                      <b-button variant="link" style=";color:#ee8174;" to="/register" >Register Now</b-button>
                    </CCol> -->
                  </CRow>
                </CForm>
              </CCardBody>
                <CCardFooter >
                    <!-- <CRow >
                        <div style="width:100%; text-align:center;">
                            <span style="color:#C1C1C1;  border-bottom: solid; border-bottom-color: #C1C1C1">Forgot Password?</span>
                        </div>
                    </CRow> -->
                    <CRow >
                        <p style="width:100%; color:#C1C1C1; text-align:center">OR CONTINUE WITH</p>
                    </CRow>
                    <CRow >
                      <CCol col="12" class="text-center">
                         <img src="/img/Facebook-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                          padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onFacebookSignIn" />
                        <!-- <b-button   variant="primary" @click="onFacebookSignIn" >Facebook</b-button> -->
                        <img src="/img/Google-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                          padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onGoogleSignIn" />
                          <img src="/img/Apple-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                          padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onAppleSignIn" />
                      </CCol>
                       
                    </CRow>
                    <CRow vif="successMsg" class="pt-3">
                      <CCol col="12" >
                        <b-alert   dismissible @dismissed="msg=''" variant="light">
                          <h5 class="alert-heading">Email sent successfully!</h5>
                          <p>
                              Please check your account and find out email to reset password
                          </p>
                        </b-alert>
                      </CCol>
                    </CRow>
                </CCardFooter>

            </CCard>
            
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
   <TheFooter/>
  </div>
  
</template>

<script>
//import firebase from 'firebase'
import TheHeader from '@/components/layout/TheDarkHeader'
import TheFooter from '@/components/layout/TheDarkFooter'
import axios from 'axios';
import '@/assets/app.css'

export default {
  name: 'ForgotPassword',
  components: {
   // TheSidebar,
    TheHeader,
    TheFooter,
  },
  data () {
    return {
        email: '',
        successMsg:false,
        loading:false,
        errors:{},
    }
  },
  methods: {
      resetPassword(){
        var self = this;
        //validate email
        self.errors = {}; 
        if(self.email==''){
          self.errors.email='Incorrect email'
        }
        if(Object.keys(self.errors).length>0){
           return ;
         }
        var url = process.env.VUE_APP_API_BASE_URL + '/api/user/forgot/password?username='+self.email;
        axios.get(url)
        .then(() => {
            self.successMsg = true;
        })
        .catch(e => {
          console.log(e);
        })


      },
      onFacebookSignIn(){
        this.$store.dispatch('auth/signInWithFacebook')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            console.log(err);
            this.error = err.message;
        });
      },
      onGoogleSignIn(){
         this.$store.dispatch('auth/signInWithGoogle')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            console.log(err);
            this.error = err.message;
        });
      },
      onAppleSignIn(){
        this.$store.dispatch('auth/signInWithApple')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            console.log(err);
            this.error = err.message;
        });
      },
       
    }

}
</script>
<style scoped>
     
 
     
</style>

